import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BackToFiltersButtonContainer } from './styled';
import { Icon } from '../../Icon';
import { Typography } from '../../ui/Typography';
import BackToFiltersIcon from '../../../public/static/images/new_search/icons/back-to-filters.svg';

interface BackToFiltersButtonProps {
  mapBlockRef: React.MutableRefObject<HTMLDivElement | null>;
}

export enum MapButtonEnum {
  top = 'top',
  fixed = 'fixed',
  bottom = 'bottom'
}

const TOP_OFFSET = 75;
const BUTTON_HEIGHT = 36;

export const BackToFiltersButton: React.FC<BackToFiltersButtonProps> = ({
  mapBlockRef
}) => {
  const { t } = useTranslation();
  const [position, setPosition] = useState(MapButtonEnum.top);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const rect = mapBlockRef.current?.getBoundingClientRect();
      if (!rect) return;

      let nextPosition = MapButtonEnum.fixed;

      if (rect.top >= TOP_OFFSET) {
        nextPosition = MapButtonEnum.top;
      }

      if (rect.bottom <= TOP_OFFSET + BUTTON_HEIGHT + 10) {
        nextPosition = MapButtonEnum.bottom;
      }

      setPosition(prev => (prev === nextPosition ? prev : nextPosition));
    };

    window.addEventListener('scroll', handleScroll);

    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [mapBlockRef]);

  return (
    <BackToFiltersButtonContainer onClick={scrollToTop} $position={position}>
      <Icon
        width={16}
        height={16}
        IconComponent={BackToFiltersIcon}
        indent={false}
      />
      <Typography tag="body_1">{t('search.buttons.rise')}</Typography>
    </BackToFiltersButtonContainer>
  );
};
